import * as Msal from 'msal'

import { msalConfig, loginRequest, tokenRequest } from './msal/authConfig'
import { b2cPolicies } from './msal/policies'

export default class AuthService {

    static localStoragePrefix = "rekom.life."

    constructor(onAuthenticated) {


        this.permissions = null;

        this.onAuthenticated = onAuthenticated;

        this.msalObj = new Msal.UserAgentApplication(msalConfig);

        // Register Callbacks for Redirect flow
        let ctx = this;
        this.msalObj.handleRedirectCallback((error, response) => this.authRedirectCallBack(ctx, error, response));
    }

    authRedirectCallBack(ctx, error, response) {
        // Error handling
        if (error) {
            console.error(error);

            // Check for forgot password error
            // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
            if (error.errorMessage.indexOf("AADB2C90118") > -1) {
                try {
                    localStorage.setItem('rekom.life.isResettingPassword', true);

                    this.msalObj.loginRedirect(b2cPolicies.authorities.resetPassword); // Password reset policy/authority
                } catch (err) {
                    localStorage.setItem('rekom.life.isResettingPassword', false);

                    console.error(err);
                }
            } else if (error.errorMessage.indexOf("AADB2C90091") > -1) {
                localStorage.setItem('rekom.life.isResettingPassword', false);
            } else {
                //console.log("Acc response", response);
                alert(error.errorMessage);
            }
        } else {
            // We need to reject id tokens that were not issued with the default sign-in policy.
            if (response.tokenType === "id_token" && response.idToken.claims['tfp'] === b2cPolicies.names.resetPassword) {
                localStorage.setItem('rekom.life.isResettingPassword', false);
                this.logout();
                console.log("Password has been reset successfully. \nPlease sign-in with your new password.");
            } else if (response.tokenType === "id_token" && response.idToken.claims['tfp'] === b2cPolicies.names.signIn) {
                console.log("id_token acquired at: " + new Date().toString());
                //alert('Got id_token from sign in policy');
                //this.acquireTokenSilent();
                /*if (this.msalObj.getAccount()) {
                //updateUI();
                }*/
                //ctx.getTokenRedirect();
                //window.location.reload();

                //this.login(window.location.href)

            } else if (response.tokenType === "access_token") {
                console.log("authRedirectCallBack:", response);
                localStorage.setItem('rekom.life.accessToken', response.accessToken);
                localStorage.setItem('rekom.life.isAuthed', 'true');

                this.onAuthenticated(response);
            } else {
                console.log("Token type is: " + response.tokenType);
            }
        }
    }

    isAuthenticated() {
        var account = this.msalObj.getAccount();
        var accessToken = localStorage.getItem('rekom.life.accessToken');

        if (account && accessToken) {
            return true;
        }

        return false;
    }

    getAccount() {
        return this.msalObj.getAccount();
    }

    login(redirectUrl) {
        localStorage.setItem('rekom.life.redirectUrl', redirectUrl);

        const isResettingPassword = localStorage.getItem('rekom.life.isResettingPassword');
        if (isResettingPassword === 'true') {
            localStorage.setItem('rekom.life.isResettingPassword', false);
            return;
        }

        // if the user is already logged in you can acquire a token
        if (this.msalObj.getAccount()) {
            this.acquireTokenSilent();
        } else {
            // user is not logged in, you will need to log them in to acquire a token
            //this.loginPopup();
            this.loginRedirect();
        }
    }

    logout() {
        // Removes all sessions, need to call AAD endpoint to do full logout
        this.msalObj.logout();
        localStorage.clear();
    }

    loginPopup() {
        this.msalObj.loginPopup(loginRequest)
            .then(response => {
                // get access token from response
                // response.accessToken
                console.log("loginPopup:", response);

                if (response.tokenType === 'id_token') {
                    console.log('Got id_token');

                    this.acquireTokenSilent();
                }
            })
            .catch(err => {
                console.error("Error in loginPopup:")
                console.error(err);
            });
    }

    loginRedirect() {
        this.msalObj.loginRedirect(loginRequest);
    }

    getTokenSilent() {
        return this.msalObj.acquireTokenSilent(tokenRequest);
    }

    acquireTokenSilent() {
        this.msalObj.acquireTokenSilent(tokenRequest)
            .then(response => {
                // get access token from response
                // response.accessToken
                //console.log("acquireTokenSilent:", response);

                if (response.tokenType === 'access_token') {
                    this.onAuthenticated(response);
                }
            })
            .catch(err => {
                console.log(err);

                // could also check if err instance of InteractionRequiredAuthError if you can import the class.
                if (err.name === "InteractionRequiredAuthError") {
                    return this.msalObj.acquireTokenRedirect(tokenRequest)
                        .then(response => {
                            //console.log("acquireTokenRedirect:", response);

                            if (response.tokenType === 'access_token') {
                                this.onAuthenticated(response);
                            }
                        })
                        .catch(err => {
                            // handle error
                            console.log("Error in acquireTokenRedirect:")
                            console.log(err);
                        });
                }
            });
    }
/* 
    hasPermission(permId) {
        this.getPermissions();
        if (!this.permissions) return false;
        return this.permissions.globalPermissions.includes(permId);
    }

    hasPermissionForActiveVenue(permId) {
        let activeVenue = localStorage.getItem("activeVenue");
        // If the active venue is not currently set, but we do have permissions, then assume the first venue is selected (because the router does the same)
        if (activeVenue == null && this.permissions && this.permissions.venuePermissions.length > 0) activeVenue = this.permissions.venuePermissions[0].venueId;
        return this.hasPermissionForEntity(permId, activeVenue)
    }

    hasPermissionForEntity(permId, forEntityId) {
        this.getPermissions();
        if (!this.permissions) return false;
        return this.permissions.globalPermissions.includes(permId) || _.some(this.permissions.venuePermissions, v => v.venueId === forEntityId && v.permissions.includes(permId))
    }

    getPermissions() {
        if (!this.isAuthenticated) return null;
        if (this.permissions != null) return this.permissions;
        const url = "https://rekom-life-admin-api-prod.azurewebsites.net/api/Idam/User/Permissions?useCache=true"
        const accessToken = localStorage.getItem(AuthService.localStoragePrefix + 'accessToken');
        try {
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open("GET", url, false);
            xmlHttp.setRequestHeader("Authorization", "Bearer " + accessToken);
            xmlHttp.send(null);
            this.permissions = JSON.parse(xmlHttp.responseText);
            console.info("[AuthService]: User permissions -", this.permissions);
        } catch (e) {
            console.error("[AuthService]: Failed to retrieve permissions for user", e);
            this.permissions = null;
        }

    }
 */

    getUser() {
        console.log("[AuthService]: User - ", this.msalObj.account);
        return {
            name: this.msalObj.account.name,
            firstName: this.msalObj.account.idTokenClaims.given_name,
            lastName: this.msalObj.account.idTokenClaims.family_name,
            role: this.msalObj.account.idTokenClaims.extension_UserRole,
            type: this.msalObj.account.idTokenClaims.extension_UserType
        }
    }
}